import React, { useState } from "react";
import { TimeSheetHeading } from "./heading";
import { TimeSheetButton } from "./timeSheetButton";
import { PreviewImage } from "./previewImage";
import { SHOW_TIMESHEET_TEXT, HIDE_TIMESHEET_TEXT, UPLOAD_TIMESHEET_TEXT } from "./constant";
import { updateTimecardTemplate, deleteTimecardTemplate } from "./api";
import { uploadFacilityTimeCardTemplate } from "@src/utils/fileUpload";
import { showErrorToast } from "@src/appV2/lib/Notifications";
import { useGetFacilityTimeCardTemplate } from "@src/appV2/FacilityProfile/api/useGetFacilityTimeCardTemplate";

export function ReferenceTimeSheet({ userId }) {
  const [showImage, setShowImage] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  const {
    data: facilityTimeCardTemplate,
    isLoading: isLoadingTimeCardTemplate,
    isSuccess,
    remove,
    refetch,
  } = useGetFacilityTimeCardTemplate({ facilityId: userId });

  const handleFileInput = async (uploadedImage) => {
    if (uploadedImage.size > 307200) {
      return showErrorToast("File too large");
    }

    setIsUpdating(true);

    try {
      // FIXME: Automatically disabled during ESLint config update
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const body: any = await uploadFacilityTimeCardTemplate(userId, uploadedImage);
      await handleUpload(body.fileKey, body.folderName);

      await refetch();
    } catch {
      showErrorToast("Unable to upload workplace time card template");
    } finally {
      setIsUpdating(false);
    }
  };

  const handleUpload = async (fileKey, folderName) => {
    await updateTimecardTemplate({
      userId,
      timeCardTemplateFileKey: fileKey,
      timeCardTemplateFolderName: folderName,
    });
  };

  const toggleShowImage = () => {
    setShowImage(!showImage);
  };

  const removeImage = async () => {
    try {
      setIsUpdating(true);

      await deleteTimecardTemplate({
        userId,
      });

      remove();
    } catch {
      showErrorToast("Unable to delete workplace time card template");
    } finally {
      setIsUpdating(false);
    }
  };

  const buttonTitle = () => {
    if (isSuccess && showImage) {
      return HIDE_TIMESHEET_TEXT;
    } else if (isSuccess && !showImage) {
      return SHOW_TIMESHEET_TEXT;
    } else {
      return UPLOAD_TIMESHEET_TEXT;
    }
  };

  return (
    <>
      <TimeSheetHeading title="Reference Timesheet" />
      <TimeSheetButton
        title={buttonTitle()}
        onFileChange={handleFileInput}
        toggleShowImage={toggleShowImage}
        loading={isLoadingTimeCardTemplate}
      />
      <PreviewImage
        src={facilityTimeCardTemplate?.distributionUrl}
        show={showImage}
        onFileChange={handleFileInput}
        removeImage={removeImage}
        loading={isUpdating}
      />
    </>
  );
}
